// home-editor-07 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "Arraste para mudar a ordem das seções na Home do app, e use o lápis para renomear o título de cada uma. É necessário reabrir o App para visualizar as alterações.": "Arrastre para cambiar el orden de las secciones del Inicio de la app y use el lápiz para renombrar el título de cada una. Es necesario reabrir la app para ver los cambios.",
    "Em branco, o app mostra “%{padrao}”.": "En blanco, la app muestra “%{padrao}”.",
    "No app: %{titulo}": "En la app: %{titulo}",
    "Renomear o título desta seção": "Renombrar el título de esta sección",
    "Salvar título": "Guardar título",
};

export default catalogo;
